/* eslint-disable @typescript-eslint/dot-notation */
// tslint:disable: no-string-literal
import { Component, OnInit, Input, OnDestroy, ElementRef } from '@angular/core';
import { EventVM } from 'src/app/models/event/event';
import { BetTypeOutcomeShowType, EventMappingType, EventType, PageType, SBVDisplayType, SiteViewConfiguration, SpecialOfferType } from 'src/app/models/enums';
import { EventsService } from 'src/app/services/events.service';
import { TicketService } from 'src/app/services/ticket.service';
import { IBet } from 'src/app/models/bet/bet';
import { IBetOutcome } from 'src/app/models/bet/betOutcome.interface';
import { IBetsAndOutcomesForBetTypeGroup } from 'src/app/models/bet/betsAndOutcomesForBetTypeGroup.interface';
import { StorageService } from 'src/app/services/util/storage.service';
import { IBetTypeGroupingTemplateItem } from 'src/app/models/betType/betTypeGroupingTemplateItem.interface';
import { Subscription } from 'rxjs';
import { ITicketItemIdentifier } from 'src/app/models/ticket/ticketItemIdentfier.interface';
import { blinkAnimation } from 'src/app/animations/blink';
import { MessagingService } from 'src/app/services/messaging.service';
import { UserService } from 'src/app/services/user.service';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { UtilityService } from 'src/app/services/util/utility.service';
import { RegionNameMap } from 'src/app/models/util/regionNameMap';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { SportsService } from 'src/app/services/sports.service';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { DeployParams } from 'src/app/deployParams';
import { CacheService } from 'src/app/services/cache.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.less'],
  animations: [blinkAnimation]
})
export class EventComponent implements OnInit, OnDestroy {

  arr = Array;
  private language: string;
  languageForBetradar: string;
  eventMappingTypeEnum = EventMappingType;
  sbvDisplayTypeEnum = SBVDisplayType;
  pageTypeEnum = PageType;
  isUserLogedIn = false;
  betTypeOutcomeShowTypeEnum = BetTypeOutcomeShowType;
  dynamicTranslations = DynamicTranslations;
  scrollY: number;
  mobileScrollContent = document.getElementsByClassName('content-wrap')[0];
  eventTypeEnum = EventType;
  requiredNonSbItems = ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS;

  @Input()
  betsAndOutcomes: IBetsAndOutcomesForBetTypeGroup;

  @Input()
  betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[];

  @Input()
  event: EventVM;

  @Input()
  pageType: PageType;

  private subscription: Subscription = new Subscription();

  showH2Hwidget = false;

  viewConfigurations = ViewConfigurations;
  regionNameMap = RegionNameMap;

  siteViewConfigurationEnum = SiteViewConfiguration;
  enviroment = environment;

  specialOfferTypeEnum = SpecialOfferType;

  selectedBetsByBetTypeId: { [betTypeId: number]: { bet: IBet; betOutcomes: { [betTypeOutcomeId: number]: IBetOutcome[] } }};
  isAnimationDisabled = false;

  constructor(
    private eventsService: EventsService,
    private ticketService: TicketService,
    private messagingService: MessagingService,
    private userService: UserService,
    private storage: StorageService,
    private utilityService: UtilityService,
    private queryParamService: QueryParamsService,
    private sportsService: SportsService,
    private cacheService: CacheService
  ) {
    this.language = storage.language;
    this.languageForBetradar = LocaleHelper.languageForBetradar[this.language];
    this.subscription.add(this.ticketService.ticketItemAddedRemoved$.subscribe((identifier) => {
      this.selectBetOutcomeFromTicket(identifier);
    }));
    this.subscription.add(this.eventsService.expandedEvent$.subscribe((ev) => {
      if (!ev && this.scrollY) {
        setTimeout(() => {
          if (utilityService.mobileView && this.mobileScrollContent) {
            this.mobileScrollContent.scroll(0, this.scrollY);
          } else {
            window.parent.scroll(0, this.scrollY);
          }
          this.scrollY = null;
        }, 100);
      }
    }));
  }


  headToHeadWidget() {
    if (!this.showH2Hwidget) {
      this.eventsService.openCloseHeadToHeadWidget(this.event.betRadarEventId);
    }
    else {
      this.eventsService.openCloseHeadToHeadWidget();

      if (window['SIR']) {
        window['SIR']('removeWidget', document.querySelector('.sr-widget'));
      }
    }
  }

  ngOnInit(): void {
    if (this.userService.user.userName) {
      this.isUserLogedIn = true;
    } else {
      this.isUserLogedIn = false;
    }
    if (this.sportsService.loadCompetitionOrEventFromQuery && this.queryParamService.queryParameters.eventId && this.event.id === this.queryParamService.queryParameters.eventId) {
      setTimeout(() => {
        this.showDetail(this.event);
        this.sportsService.loadCompetitionOrEventFromQuery = false;
      });
    }
  }


  showDetail(event: EventVM) {
    this.eventsService.expandEvent(event);
    if (this.utilityService.mobileView && this.mobileScrollContent) {
      this.scrollY = this.mobileScrollContent.scrollTop;
    } else {
      this.scrollY = window.parent.scrollY;
    }
    window.parent.scroll(0, 0);
  }

  setEventForMessaging(event: EventVM) {

    event.isNotificationEnabled = !event.isNotificationEnabled;
    this.messagingService.sendEventForMessaging(event);

  }

  toggleEventOutcome(event: EventVM, bet: IBet, outcome: IBetOutcome, betTypeOutcomeName: string, betTypeName: string) {
    if (!((event.isPlayable && bet.isPlayable && outcome.isPlayable) || outcome.isSelected)) {
      return;
    }
    this.ticketService.toggleEventOutcome(event, bet, outcome, betTypeOutcomeName, betTypeName);
  }

  selectBetOutcomeFromTicket(identifier: ITicketItemIdentifier) {
    if (identifier.eventId !== this.event.id) {
      return;
    }

    if (!this.betsAndOutcomes.betOutcomes[identifier.betId] || !this.betsAndOutcomes.betOutcomes[identifier.betId][identifier.betTypeOutcomeId]) {
      return;
    }
    const betOutcome = this.betsAndOutcomes.betOutcomes[identifier.betId][identifier.betTypeOutcomeId].find(bo => bo.id === identifier.betOutcomeId);
    if (betOutcome) {
      if (identifier.isAdded) {
        betOutcome.isSelected = true;
      } else {
        betOutcome.isSelected = false;
      }
    }
  }

  changeSbv(betTypeId: number, betId: number) {
    if (!this.selectedBetsByBetTypeId) {
      this.selectedBetsByBetTypeId = {};
    }
    if (!this.selectedBetsByBetTypeId[betTypeId] || this.selectedBetsByBetTypeId[betTypeId].bet?.id !== betId) {
      this.isAnimationDisabled = true;
      this.selectedBetsByBetTypeId[betTypeId] = this.cacheService.getBetAndOutcomes(this.event.id, betTypeId, betId);
      setTimeout(() => {
        this.isAnimationDisabled = false;
      }, 50);
    }
  }

  getSportName(sportId: number) {
    return this.utilityService.getSportIcon(sportId);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
